export type ConnectorToolActivation =
  | { event: 'tool:start-connecting'; payload: { sourceNodeId: string } }
  | { event: 'tool:arm-connecting' };

export const resolveConnectorToolActivation = (
  selectedIds: Iterable<string> | null | undefined,
): ConnectorToolActivation => {
  const ids = selectedIds ? [...selectedIds] : [];
  if (ids.length === 1 && ids[0]) {
    return { event: 'tool:start-connecting', payload: { sourceNodeId: ids[0] } };
  }
  return { event: 'tool:arm-connecting' };
};
